var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionPnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.33333C6.5 6.83888 6.64662 6.35553 6.92133 5.94441C7.19603 5.53329 7.58648 5.21285 8.04329 5.02364C8.50011 4.83442 9.00277 4.78491 9.48773 4.88137C9.97268 4.97783 10.4181 5.21594 10.7678 5.56557C11.1174 5.9152 11.3555 6.36066 11.452 6.84561C11.5484 7.33056 11.4989 7.83323 11.3097 8.29004C11.1205 8.74686 10.8 9.13731 10.3889 9.41201C9.9778 9.68671 9.49445 9.83333 9 9.83333V10.6667M9 13.1667H9.00833M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionPnc);
export default __webpack_public_path__ + "static/media/questionPnc.bc30eadc2781725201c56f26f08def5c.svg";
export { ForwardRef as ReactComponent };